import React, { useContext } from 'react';

import { DataContext } from '../context/DataContext';

import { Snackbar, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AppSnackbar = () => {
    const { data: { snackbar_status: { open, message } }, setData } = useContext(DataContext);

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={
                () => setData(e => ({
                    ...e, snackbar_status: { ...e.snackbar_status, open: false }
                }))
            }
            message={ message }
            action={
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={
                        () => setData(e => ({
                            ...e, snackbar_status: { ...e.snackbar_status, open: false }
                        }))
                    }
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
            disableWindowBlurListener
        />
    );
};

export default AppSnackbar;